import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card } from '../../ui/card';
import { Badge } from '../../ui/badge';
import {
  formatQueueDateTime,
  getCommandCenterWorkspaceLabel,
} from './commandCenterQueueUtils';

export default function ResolvedTodaySection({ items }) {
  if (!items.length) {
    return null;
  }

  return (
    <div>
      <div className="mb-3 flex items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold text-slate-900 dark:text-white">Resolved Today</h3>
          <p className="text-sm text-slate-600 dark:text-gray-400">
            Keep closed loops visible so the day feels real, not theoretical.
          </p>
        </div>
        <Badge className="border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-400/20 dark:bg-emerald-500/10 dark:text-emerald-200">
          {items.length} done
        </Badge>
      </div>

      <Card className="border-slate-200 bg-white p-4 dark:border-white/10 dark:bg-[#171b20]">
        <div className="grid gap-3">
          {items.slice(0, 6).map((item) => (
            <div
              key={item.queue_item_id}
              className="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-slate-50/75 px-4 py-3 dark:border-white/10 dark:bg-white/[0.03] lg:flex-row lg:items-center lg:justify-between"
            >
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <CheckCircle2 className="h-4 w-4 text-emerald-600 dark:text-emerald-300" />
                  <p className="text-sm font-semibold text-slate-900 dark:text-white">{item.title || 'Untitled action'}</p>
                  <Badge className="border-slate-200 bg-white text-slate-700 dark:border-white/10 dark:bg-black/20 dark:text-slate-200">
                    {getCommandCenterWorkspaceLabel(item.workspace)}
                  </Badge>
                </div>
                {item.detail ? (
                  <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-gray-300">{item.detail}</p>
                ) : null}
              </div>
              <p className="text-xs text-slate-500 dark:text-gray-400">
                {item.resolved_at ? `Resolved ${formatQueueDateTime(item.resolved_at)}` : 'Resolved today'}
              </p>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
